import Vue from 'vue'
import App from './App'
import 'cssreset-init'
import '../../config/rem'
import '../../assets/style/style.css'

import Create from '../../libs/create.js';
import Alert from '../../components/Alert.vue';

Vue.prototype.$Alert = ((obj) => {
  return Create(Alert, obj).show()
})
new Vue({
  el: '#app',
  components: {
    app: App
  }
})



// WEBPACK FOOTER //
// ./src/module/directions/index.js